// react and js
import { React } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// mui
import { Box } from "@mui/material";

// components

// hooks

// i18n
import { lookupBackendMessage } from "./backendMessages";

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
// Resolves an i18n key at render time so the displayed text updates when the
// active language changes. Use this anywhere you'd otherwise store the result
// of t("…") in state — storing the raw translated string freezes the
// language at the moment the state was set.
//
// Usage:
//   setReturnMessage(<TranslatedMessage messageKey="some.key" />)
//   setReturnMessage(<TranslatedMessage messageKey="some.key" values={{ name }} />)
export function TranslatedMessage({ messageKey, fallback, values }) {
  const { t } = useTranslation();
  const options = values ? { ...values } : {};
  if (fallback !== undefined) options.defaultValue = fallback;
  return <>{t(messageKey, options)}</>;
}

TranslatedMessage.propTypes = {
  messageKey: PropTypes.string.isRequired,
  fallback: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object,
};

TranslatedMessage.defaultProps = {
  fallback: undefined,
  values: undefined,
};

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export function combineReturnMessage(content, setReturnMessage) {
  const raw = content.message || "";
  const formattedFallback = raw.charAt(0).toUpperCase() + raw.slice(1);
  // If the backend's English message matches a known signature, render the
  // i18n version via a small component that re-evaluates t() on every render
  // — so the displayed text follows the active language even after the
  // message has already been set into state. Captured groups from the regex
  // (e.g. the "wait" duration in a login-blocked message) come through as
  // interpolation values.
  const match = lookupBackendMessage(raw);
  const messageNode = match
    ? (
      <TranslatedMessage
        messageKey={match.key}
        values={match.values}
        fallback={formattedFallback}
      />
    )
    : formattedFallback;

  if (content.expected_pattern !== undefined) {
    let patterns = "";
    content.expected_pattern.forEach((pattern) => {
      patterns += `${pattern}, `;
    });

    setReturnMessage(
      <>
        {messageNode}
        <Box sx={{ m: 1 }} />
        {patterns.substring(0, patterns.length - 2)}
      </>
    );
  } else {
    setReturnMessage(messageNode);
  }
}
